import { render } from "./TriggerModal.vue?vue&type=template&id=57cbb2c6&scoped=true&ts=true"
import script from "./TriggerModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./TriggerModal.vue?vue&type=script&lang=ts&setup=true"

import "./TriggerModal.vue?vue&type=style&index=0&id=57cbb2c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57cbb2c6"],['__file',"src/pages/notificationmodal/TriggerModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57cbb2c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57cbb2c6', __exports__)) {
    api.reload('57cbb2c6', __exports__)
  }
  
  module.hot.accept("./TriggerModal.vue?vue&type=template&id=57cbb2c6&scoped=true&ts=true", () => {
    api.rerender('57cbb2c6', render)
  })

}


export default __exports__